/** @format */

import {styled} from '@mui/material/styles';

// Light tooltip body shown on the dark Chief Report page (intentional black-on-white).
const PopupBody = styled('div')(
  ({theme}) => `
  width: 320px;
  padding: 12px;
  margin: 8px;
  border-radius: 8px;
  box-shadow: ${
    theme.palette.mode === 'dark' ? '0px 4px 8px rgb(0 0 0 / 0.7)' : '0px 4px 8px rgb(0 0 0 / 0.1)'
  };
  background: white;
  color: black;
  position: relative;
  z-index: 3
`,
);

export default PopupBody;
